import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useCountry } from '@/contexts/CountryContext';

const BG_IMAGES = {
  albania: 'https://images.pexels.com/photos/33945650/pexels-photo-33945650.jpeg',
  kosovo: 'https://images.unsplash.com/photo-1693323243729-b1609557938f',
  'north-macedonia': 'https://images.unsplash.com/photo-1684846836837-a56157f8e461',
};

export const ExperiencesBanner = () => {
  const { country } = useCountry();
  const bg = BG_IMAGES[country.code] || BG_IMAGES.albania;
  return (
    <section className="py-16 bg-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="relative rounded-2xl overflow-hidden shadow-2xl">
          <div className="absolute inset-0">
            <img alt={`${country.name} Adventures`} className="w-full h-full object-cover" src={bg} />
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-black/50" />
          </div>
          <div className="relative px-6 sm:px-8 py-16 text-center text-white">
            <h2 className="font-heading text-4xl md:text-5xl font-bold mb-4">
              Book Authentic {country.name} Experiences
            </h2>
            <p className="text-xl md:text-2xl text-white/90 mb-8 max-w-3xl mx-auto">
              Guided Tours • Outdoor Adventures • Private Transfers • Cultural Workshops
            </p>
            <Button variant="green" size="xl" asChild className="px-10 py-7 text-xl font-semibold shadow-xl">
              <Link to="/services">Explore All Tours <ArrowRight className="w-5 h-5" /></Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
